import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/rolesReducer";
import rootSaga from "./redux/rolesSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { RolesModule } from "./RolesModule";

const Roles = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "roles", rootSaga)}>
      <ErrorBoundary moduleName="roles" {...notifications}>
        <RolesModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default Roles;
